import VueRouter from 'vue-router';
import Vue from '../vue/common/vue-common';
import Avaliacoes from '../vue/components/avaliacoes/Avaliacoes.vue';
import AvaliacoesForm from '../vue/components/avaliacoes/AvaliacoesForm.vue';
import AvaliacoesHome from '../vue/components/avaliacoes/AvaliacoesHome.vue';
import AvaliacoesNotFound from '../vue/components/avaliacoes/AvaliacoesNotFound.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    base: '/avaliacoes',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        {
            name: 'home',
            path: '/',
            component: AvaliacoesHome,
        },
        {
            name: 'form',
            path: '/:productId(\\d+)',
            component: AvaliacoesForm,
        },
        {
            name: 'not-found',
            path: '/nao-encontrada',
            component: AvaliacoesNotFound,
        },
        { name: 'redirect', path: '*', redirect: '/' },
    ],
});

new Vue({
    el: '#avaliacoes-vue',
    template: '<Avaliacoes/>',
    components: { Avaliacoes },
    router,
});
